import { DatePicker, DatePickerProps } from '@mui/x-date-pickers-pro';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { DateTime } from 'luxon';
import React, { ReactNode } from 'react';
import { FieldError } from 'react-hook-form';

export type DatePickerBaseProps = {
  value: DateTime | null;
  label?: ReactNode;
  sx?: any;
  onChange: (value: any) => void;
  name?: string;
  noDateLabel?: string;
  disabled?: boolean;
  maxDate?: DateTime;
  minDate?: DateTime;
  openTo?: 'day' | 'month' | 'year';
  helperText?: ReactNode;
  error?: FieldError;
  'data-testid'?: string;
  formatValue?: (val: DateTime) => any;
} & Partial<DatePickerProps>;

const DatePickerBase = React.forwardRef<HTMLInputElement, DatePickerBaseProps>(
  (
    {
      value,
      label,
      onChange,
      name,
      noDateLabel,
      openTo = 'day',
      helperText,
      error,
      'data-testid': dataTestId,
      formatValue = val => val,
      ...rest
    },
    ref,
  ) => {
    return (
      <DatePicker
        value={value ?? null}
        label={label}
        openTo={openTo}
        views={['year', 'month', 'day']}
        onChange={newValue => {
          if (!newValue) {
            onChange(null);
          } else {
            onChange(formatValue(newValue));
          }
        }}
        inputRef={ref}
        name={name}
        slotProps={{
          textField: {
            name,
            helperText: (
              <IncFormHelperText error={error} helperText={helperText} />
            ),
            error: !!error,
            //@ts-ignore
            'data-testid': dataTestId,
            size: 'small',
            margin: 'normal',
          },
          field: {
            clearable: true,
          },
        }}
        disableHighlightToday
        {...rest}
      />
    );
  },
);

export default DatePickerBase;
